import {createSlice} from "@reduxjs/toolkit";

const initialPasoTres = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    pasoTresAlDosInformacion: undefined,
    extrasInformacion:undefined,
    lastError: null
  };

  export const callTypes = {
    list: "list",
    action: "action"
  };


  export const pasoTresSlice=createSlice({
    name:"pasoTres",
    initialState:initialPasoTres,
    reducers:{
      catchErrorPasoTresAlDos:(state,action)=>{
          state.error = action.payload.error.clientMessage;
          state.pasoTresAlDosInformacion=undefined;
          if(action.payload.callType===callTypes.list){
              state.listLoading=false;
          }else{
              state.actionsLoading=false;
          };
      },
      catchErrorPasoTresAlCuatro:(state,action)=>{
        state.error = action.payload.error.clientMessage;
        state.extrasInformacion=undefined;
        if(action.payload.callType===callTypes.list){
            state.listLoading=false;
        }else{
            state.actionsLoading=false;
        };
    },
      starCall:(state,action)=>{
          state.error=null;
          if(action.payload.callType===callTypes.list){
              state.listLoading=true;
          }else{
              state.actionsLoading=true;
          };
      },
      pasoTresAlDosFetched:(state,action)=>{
          state.actionsLoading=false;
          state.pasoTresAlDosInformacion=action.payload.pasoTresAlDosInformacion;
          state.error=null;
      },
      pasoTresAlCuatroFetched:(state,action)=>{
        state.actionsLoading=false;
        state.extrasInformacion=action.payload.extrasInformacion;
        state.error=null;
    },
    stateLimpiar: (state, action) => {
        state.actionsLoading = false;
        state.extrasInformacion = undefined;
        state.pasoTresAlDosInformacion = null;
    },
    }
});